import { useQuery } from "@tanstack/react-query";
import Link from "next/link";

import Layout from "../components/layouts/layout.comp";
import { ListSection, Tag } from "../components/reuseables/list.comp";
import specialistCore from "../core/specialist.core";
import { useTranslation } from "../core/translation.core";
import ErrorCenterIcon from "../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../icons/loadingOvalCenter.icon";
import { Specialist } from "../types/specialist";
import AddLink from "../components/form/addLink.comp";

export default function SpecialistsPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.specialist.specialist)} titleBtn={<AddLink id="specialist-create" href="/specialist/create" />}>
      <ListSection>
        <List />
      </ListSection>
    </Layout>
  );
}

const List = () => {
  const { t, msg } = useTranslation();
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["specialists"],
    queryFn: () => specialistCore.listSpecialists(),
  });

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <div id="specialist-list" className="pt-6 lg:pt-0">
      <div className="hidden lg:grid lg:grid-cols-[6fr_3fr_3fr_2fr] gap-6 px-6 py-3 text-sm font-medium">
        <div>{t(msg.specialist.name)}</div>
        <div>{t(msg.ship.type)}</div>
        <div></div>
      </div>

      {data!.map((a) => (
        <Row key={a.id} specialist={a} />
      ))}
    </div>
  );
};

function Row({ specialist }: { specialist: Specialist }) {
  const { t, msg } = useTranslation();

  return (
    <div className="specialist-row grid grid-cols-2 lg:grid-cols-[6fr_3fr_3fr_2fr] gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm group/edit">
      <div data-value={specialist.type}>
        <Tag>{t(msg.specialist.name)}</Tag>
        <p>{`${specialist.firstName} ${specialist.lastName}`}</p>
      </div>
      <div data-value={specialist.type}>
        <Tag>{t(msg.specialist.name)}</Tag>
        <p>{specialist.type}</p>
      </div>
      <div className="col-span-2 lg:col-span-1 opacity-0 group-hover/edit:opacity-100">
        <Link className="specialist-edit underline" href={`/specialist/edit/${specialist.id}`}>
          {t(msg.form.edit)}
        </Link>
      </div>
    </div>
  );
}
